
import { defineComponent } from "vue";
import { ImagePreview } from "vant";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation } from "swiper";
require("swiper/swiper.less");
require("swiper/components/navigation/navigation.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Navigation]);
export default defineComponent({
  components: { ...SWIPER_COMPONENTS },

  data() {
    return {
      swiper: <any>null,
      tabIndex: 0,
      picList: [
        'https://mm2015.mamalaile.com.cn/2f1f2f7b1cdd3c185d968557eff03e77.png',
        'https://mm2015.mamalaile.com.cn/35c590112ac98dfc5638792a91ff6580.png',
        'https://mm2015.mamalaile.com.cn/49820946b6abf4ead9a3e6d47b7040e2.png',
        'https://mm2015.mamalaile.com.cn/940edc836f071019fe01a82d56f34885.png',
        'https://mm2015.mamalaile.com.cn/ee8867cc5d1caf5b5c18a60f060b8fa8.png',
        'https://mm2015.mamalaile.com.cn/a93a463bbb4156920be29e6f650149c9.png',
        'https://mm2015.mamalaile.com.cn/00b282297e1288c142fb24bd43fec6b2.png',
        'https://mm2015.mamalaile.com.cn/e8460cd3cba9f18c31bacc0681d5eb35.png',
        'https://mm2015.mamalaile.com.cn/034b64ffd7bf0b77222d9bb7fb8b82ab.png',
        'https://mm2015.mamalaile.com.cn/c40e475096a7ca80805805b64ea7d763.png',
      ]
    };
  },

  methods: {
    previewImage(index: number) {
      ImagePreview({
        images: this.picList,
        startPosition: index,
        closeable: true
      });
    }
  }
});
